module.exports = __webpack_public_path__ + "img/prznce.e8589d8e.png";